import $ from '@modules/jquery-import';
import {jqueryEasing} from '@modules/lazy-imports';

// offsetRelative (or, if you prefer, positionRelative)
$.fn.offsetFromAncestor = function ( top ) {
    var $this = $( this );
    var $parent = $this.offsetParent();
    var offset = $this.position();
    if ( !top ) {
        return offset;
    }// Didn't pass a 'top' element
    else if ( $parent.get( 0 ).tagName == 'BODY' ) {
        return offset;
    }// Reached top of document
    else if ( $( top, $parent ).length ) {
        return offset;
    }// Parent element contains the 'top' element we want the offset to be relative to
    else if ( $parent[0] == $( top )[0] ) {
        return offset;
    }// Reached the 'top' element we want the offset to be relative to
    else { // Get parent's relative offset
        var parent_offset = $parent.offsetFromAncestor( top );
        offset.top += parent_offset.top;
        offset.left += parent_offset.left;
        return offset;
    }
};

$.fn.positionRelative = function ( top ) {
    return $( this ).offsetFromAncestor( top );
};

$.fn.scrollToElement = async function ( options ) {
    await jqueryEasing();

    var dfd = new $.Deferred(),
        defaults = {
            effect_speed: 500,
            offset: 0
        },
        opt = $.extend( defaults, options || {} ),
        delay = parseInt( opt.delay, 10 ),
        body_elm = $( upi.conf.SCROLL_CONTEXT ),
        target = $( this );

    function doScroll() {
        $.when(
            body_elm.data( 'is-scroll-animating', true ).stop()
                .animate( {
                        scrollTop: target.offsetFromAncestor( '#page-content' ).top + opt.offset
                    },
                    opt.effect_speed,
                    'easeInOutCirc'
                ).promise()
        ).done( function () {
            body_elm.data( 'is-scroll-animating', false );
            dfd.resolve();
        } );
    };

    if ( delay && !isNaN( delay ) ) {
        setTimeout( doScroll, delay )
    }
    else {
        doScroll();
    }

    return dfd.promise();
};

$.fn.scrollToTarget = function () {
    return $( this ).each( function () {
        var $target = $( '#' + this.href.split( '#' )[1] );
        // only attach to <a href="#target">
        if ( !this.href || !$target[0] ) {
            return;
        }

        $( this ).gotoByScroll( $target );
    } );
};

$.fn.gotoByScroll = function ( target, opt ) {
    var defaults = {
            offset: 0,
            effect_speed: 600,
            event_trigger: 'click'
        },
        opt = $.extend( defaults, opt ),
        target = $( target );

    if ( !target[0] ) {
        return;
    }

    return $( this ).each( function () {
        if ( $( this )[opt.event_trigger] ) {
            $( this )[opt.event_trigger]( function ( e ) {
                e.preventDefault();
                target.scrollToElement( opt );
            } );
        }
    } );
};
